export default __webpack_public_path__ + "static/media/AM_00826 copy.e5458504.jpg";